module.exports = __webpack_public_path__ + "static/img/portrait.fac41893.png";